import { Identifiable, Project, SecondaryCriteria } from "@planzone/dto";

function sum(numbers: number[]) {
  return numbers.reduce((total, nbr) => total + nbr, 0);
}

function average(numbers: number[]) {
  return numbers.length > 0 ? sum(numbers) / numbers.length : 0;
}

function averageIndicators(
  projects: Identifiable<Project>[],
  criteria: Identifiable<SecondaryCriteria>[],
) {
  return {
    proportionOfAccomplishedWork: average(
      projects.map(
        ({ proportionOfAccomplishedWork }) => proportionOfAccomplishedWork,
      ),
    ),
    proportionOfDelayedWork: average(
      projects.map(({ proportionOfDelayedWork }) => proportionOfDelayedWork),
    ),
    proportionOfOpenedWork: average(
      projects.map(({ proportionOfOpenedWork }) => proportionOfOpenedWork),
    ),
    totalSumOfTimeAllocatedOnTheProject: sum(
      projects.map(
        ({ totalSumOfTimeAllocatedOnTheProject }) =>
          totalSumOfTimeAllocatedOnTheProject,
      ),
    ),
    totalOfTimesSpentInProject: sum(
      projects.map(
        ({ totalOfTimesSpentInProject }) => totalOfTimesSpentInProject,
      ),
    ),
    totalOfRemainingTimeInProject: sum(
      projects.map(
        ({ totalOfRemainingTimeInProject }) => totalOfRemainingTimeInProject,
      ),
    ),
    finalPlannedValueOfProject: sum(
      projects.map(
        ({ finalPlannedValueOfProject }) => finalPlannedValueOfProject,
      ),
    ),
    trackingRealCost: sum(
      projects.map(({ trackingRealCost }) => trackingRealCost),
    ),
    trackingAcquiredValue: sum(
      projects.map(({ trackingAcquiredValue }) => trackingAcquiredValue),
    ),
    allocatedBudget: sum(
      projects.map(({ allocatedBudget }) => allocatedBudget),
    ),
    realMarginBudget: sum(
      projects.map(({ realMarginBudget }) => realMarginBudget),
    ),
    plannedMarginBudget: sum(
      projects.map(({ plannedMarginBudget }) => plannedMarginBudget),
    ),
    ...criteria.reduce(
      (acc, c) => ({
        ...acc,
        [c.uuid]:
          c.type === "number"
            ? sum(
                projects.map(({ attributes }) => {
                  const value = attributes[c.uuid];

                  return !!value && !isNaN(parseFloat(value))
                    ? parseFloat(value)
                    : 0;
                }),
              )
            : "",
      }),
      {},
    ),
  };
}

function numberWithSpaces(x: string) {
  var parts = x.split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return parts.join(".");
}

function toFixed(nbr: number) {
  return typeof nbr === "number" || !isNaN(parseFloat(nbr))
    ? numberWithSpaces(nbr.toFixed(2))
    : "";
}

export { averageIndicators, toFixed };
